import { render, staticRenderFns } from "./DebtRules.vue?vue&type=template&id=6a12161c&"
import script from "./DebtRules.vue?vue&type=script&lang=ts&"
export * from "./DebtRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports